import { Spinner } from '@apollo/orbit';
import React from 'react';

import { assertUnreachable } from 'src/lib/assertUnreachable';

import {
  LaunchEntryStatusIcon,
  LaunchSequenceStepStatus,
} from '../launchHistory/launchDetails/launchSequence/launchStepProgressBar/LaunchSequenceStatusIcon';

import { LaunchesListItemInfo } from './LaunchesListItem/LaunchesListItem';

type Props = {
  progress: LaunchesListItemInfo['progress'];
};

export const LaunchesListStatusIcon = ({ progress }: Props) => {
  switch (progress) {
    case 'success':
      return (
        <LaunchEntryStatusIcon
          status={LaunchSequenceStepStatus.COMPLETED}
          className="size-4"
        />
      );
    case 'failure':
      return (
        <LaunchEntryStatusIcon
          status={LaunchSequenceStepStatus.FAILED}
          className="size-4"
        />
      );
    case 'waiting':
      return <Spinner size="tiny" />;

    default:
      return assertUnreachable(progress);
  }
};
